import { Dialog } from "primereact/dialog";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { JVChips } from "../../shared/JVChips";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { Editor } from "primereact/editor";
import { ISignatureMast } from "../../models/SignatureMast";

interface IMailContent {
  //   PO_ID?: number;
  Dates?: IMassMailDates[];
  EmailTo: string;
  EmailCC?: string;
  Subject?: string;
  EmailBody?: string;
}

interface IMassMailDates {
  From?: Date;
  To?: Date;
}

const schema = yup.object({
  //emailTo: yup.array().of(yup.string().email("Invalid Email ID")).min(1, "This field is required"),
  emailCC: yup.array().of(yup.string().email("Invalid Email ID").nullable()).nullable(),
  subject: yup.string().required("Email Subject is required"),
  to_Self: yup.boolean().nullable(),
  // to_Subvendor: yup.boolean().nullable(),
  // to_Accounts: yup.boolean().nullable(),
});

interface IProps {
  open: boolean;
  multiData: any;
  hideDialog: () => void;
  toast: any;
}

interface IMail {
  //emailTo: string[],
  emailCC: string[] | null;
  subject: string;
  emailBody: string;
  to_Self: boolean;
}

export const SendMassMail = ({
  open,
  hideDialog,
  toast,
  multiData,
}: IProps) => {
  const [loading, setLoading] = useState(false);
  const [signature, setSignature] = useState("");
  const [body, setBody] = useState<any>();

  const { control, handleSubmit, formState: { errors }, reset } = useForm<IMail>({
    resolver: yupResolver(schema),
    defaultValues: {
      emailCC: null,
      subject: "",
      emailBody: "",
    },
    shouldFocusError: false,
  });

  const sendMail = async (fbody: IMail) => {
    const newBody: any = {
      toSelf: fbody.to_Self,
      emailTo: multiData.map((el: any) => el.id),
      subject: fbody.subject,
      emailBody: body + "<br/>" + signature,
      emailCC: (fbody.emailCC || [""]).map((el: string) => el.trim()),
    };

    const ids = multiData.map((x: any) => x.id);

    if (!ids.length) {
      toast.current.show({ severity: "error", detail: "No rows selected", life: 3000 });
      return;
    }

    setLoading(true);
    // console.log(ids);

    // const response = await Fetch(
    //   "MassMail/sendMassMail",
    //   "POST",
    //   ids,
    //   `toSelf=${fbody.to_Self ? 1 : 0}`,
    //   toast,
    // );

    // const bodyPayload = {
    //   subject: fbody.subject,
    //   body: body,
    //   emailCC: fbody.emailCC
    //     ? fbody.emailCC.replace(/\s+/g, "").split(",")
    //     : [],
    // };

    const response = await Fetch(`MassMail/sendMassMail`, "POST", newBody, null, toast,);
    if (response) {
      onHide();
      toast.current.show({ severity: "success", detail: "Mail Distributed Successfully.", life: 3000 });
    }

    setLoading(false);
  };

  function onSubmit(data: IMail) {
    if (body.length < 10)
      toast.current.show({ severity: "error", detail: "Mail Body is Required With Atleast 10 Characters.", life: 3000, });
    else sendMail(data);
  }

  const onHide = () => {
    hideDialog();
    reset();
    setBody("");
  };

  const header = () => {
    return <span>Send Mail</span>;
  };

  const loadSignature = async () => {
    setLoading(true);
    const response = await Fetch("Signature_Mast", "GET", null, null, toast);
    if (response) {
      const data: ISignatureMast = await response.json();
      if (data.signature) setSignature(data.signature);
      setLoading(false);
    } else setLoading(false);
  }

  useEffect(() => {
    if (open) {
      // setBody(bodyContent);
      loadSignature();
      setBody("");
      reset({ emailCC: null, subject: "", emailBody: "", });
    }
  }, [open]);

  return (
    <Dialog visible={open} style={{ width: "80vw", overflowY: "scroll" }} header={header} className="p-fluid" onHide={onHide} draggable={false}>
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
        <div
          className="field col-12 md:col-12 p-fluid formgrid grid ml-3"
          style={{ display: "grid", gridTemplateColumns: "2fr 1fr", border: "1px solid #ced4da", borderRadius: "5px", width: "90%", alignItems: "flex-end", }}
        >
          <div
            className="col-12 md:col-12 mb-3"
            style={{ display: "flex", alignItems: "center", gap: "20px", }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <JVCheckbox column={1} label="To Self" control={control} name="to_Self" />
            </div>
            <JVChips column={1} label="CC (just Copy and paste emails, Do Not Write/Type)" control={control} name="emailCC" error={errors.emailCC && errors.emailCC?.message} separator="," />
          </div>
        </div>
        <JVInput column={1} required label="Subject" control={control} name="subject" error={errors.subject?.message} />
        <div className="col-12 md:col-12 md:col-6 mb-3">
          <label>
            Body
            <span style={{ color: "red" }}>*</span>
          </label>

          <CKEditor editor={ClassicEditor} data={body} onChange={(event, editor) => { setBody(editor.getData()); }} />
        </div>
        <div className="col-12 md:col-12 md:col-6">
          <label htmlFor="signature">Full Signature</label>
          <Editor value={signature} onTextChange={(e) => setSignature(e.htmlValue || "")} style={{ height: '320px' }} />
          {/* <CKEditor editor={ClassicEditor} data={signature} onChange={(event, editor) => { setSignature(editor.getData()); }} /> */}
          {/* <JVSunEditor value={signature} handleChange={setSignature}/> */}
        </div>
        <div className="col-12 md:col-12" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "10px", marginTop: "10px", }} >
          <Button className="field col-12 md:col-6  h-2rem" label="SEND" type="submit" loading={loading} ></Button>
          <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLOSE" onClick={onHide} type="button" ></Button>
        </div>
      </form>
    </Dialog>
  );
};
